import {qa,u} from './util/helpers'
import {locale} from './util/locale';

export default function initSubscribe() {

  const subscribeForms = qa('[subscribe-form]');

  subscribeForms.forEach((subscribeForm) => {
    const slug = subscribeForm.getAttribute('slug');

    const submitBtn = u(subscribeForm).q('[subscribe-submit]');
    const input = u(subscribeForm).q('input[type="email"]')

    subscribeForm.on('submit', (e) => {
      e.preventDefault();

      if (input.validity.typeMismatch) {
        const validity = window.MBS_LOCALIZE.checkEmail;
        input.setCustomValidity(validity);
        input.setAttribute('placeholder', validity);
        input.value = null;
        input.classList.add('--error');
        return;
      }

      if (input.validity.valueMissing) {
        input.classList.add('--error');
        return;
      }

      submitBtn.classList.add('--loading');
      const email = new FormData(subscribeForm).get('email');

      subscribeViaMindbox(email);
    });

    function setFormAsSuccess() {
      subscribeForm.classList.add('--success');
      submitBtn.classList.add('--success');
      submitBtn.classList.remove('--loading');
      // TODO: localize
      // const btnSuccessText = window.STRING_TRANSLATIONS.succes_btn[locale.short];
      submitBtn.textContent = window.MBS_LOCALIZE.success;
      submitBtn.setAttribute('disabled', true);
      input.setAttribute('disabled', true);
      input.classList.remove('--error');
    }

    function setFormAsServerError() {
      submitBtn.classList.remove('--loading');
      submitBtn.setAttribute('disabled', true);
      submitBtn.textContent = window.MBS_LOCALIZE.serverError;
      input.classList.add('--error');
    }

    function subscribeViaMindbox(email) { // eslint-disable-line
      window.mindbox('async', {
        operation: 'Lid.RegistrationOnLanding',
        data: {
          customer: {
            email,
            area: {
              ids: {
                externalId: locale.short,
              },
            },
            subscriptions: [
              {
                brand: 'Travelpayouts',
                pointOfContact: 'Email',
              },
            ],
          },
          addProductToList: {
            product: {
              ids: {
                landings: slug,
              },
            },
          },
          pointOfContact: 'main',
        },
        onSuccess: () => {
          setFormAsSuccess()
        },
        onError: (error) => {
          setFormAsServerError();
          console.log('mindbox error', error);
        },
      });
    }
  });

}
